import { Link } from 'react-router-dom'

import { Button } from '@/components/button'

export function CarbonBanner() {
  return (
    <div className="h-full bg-carbonBanner bg-cover">
      <div className="flex h-full flex-col items-center justify-center gap-5 px-5 py-5 xl:w-1/2 xl:items-start xl:justify-start xl:px-40 xl:py-20">
        <span className="rounded-lg bg-bios-100 p-2 text-center font-bold text-bios-secondary">
          C3-BIOS - O Carbono de Origem Certificada e Controlada da 6BIOS
        </span>
        <h1 className="flex text-center text-2xl font-bold text-white md:text-4xl xl:text-start">
          Desperte o Potencial Oculto da sua Terra!
        </h1>
        <div className="flex flex-1 items-center">
          <p className="my-auto text-center text-lg text-white xl:text-start">
            Transforme seu compromisso ambiental em valor tangível com os
            créditos de carbono certificados da 6Bios. Descubra como sua terra
            pode gerar retornos financeiros enquanto preserva o Planeta.{' '}
            <span className="font-bold">Explore agora!</span>
          </p>
        </div>
        <Button
          variant="outline"
          className="border border-bios-primary bg-transparent font-normal uppercase text-white"
          asChild
        >
          <Link to="/carbon">Saiba mais</Link>
        </Button>
      </div>
    </div>
  )
}
